// extracted by mini-css-extract-plugin
export default {"common-tips-container":"commontips_common-tips-container__PiGH1","tips":"commontips_tips__AWQsg","back":"commontips_back__M47RO"};